const { pickBy, keys, } = require('lodash');

const { updateRequestStatuses, } = require('../config');

// 未完了(まだ更新が反映されていない)とみなす更新リクエストステータス
const incompleteUpdateRequestStatuses = keys(pickBy(updateRequestStatuses, 'isIncomplete'));

module.exports = {
  incompleteUpdateRequestStatuses,
};
